import React from "react";

const SettingsTabs = ({ onTabChange, currentTab }) => {
  const tabs = [
    {
      id: "profile",
      label: "Profile",
      icon: (
        <>
          <path
            d="M7.99967 1.33203C6.25301 1.33203 4.83301 2.75203 4.83301 4.4987C4.83301 6.21203 6.17301 7.5987 7.91967 7.6587C7.97301 7.65203 8.02634 7.65203 8.06634 7.6587C8.07967 7.6587 8.08634 7.6587 8.09967 7.6587C8.10634 7.6587 8.10634 7.6587 8.11301 7.6587C9.81967 7.5987 11.1597 6.21203 11.1663 4.4987C11.1663 2.75203 9.74634 1.33203 7.99967 1.33203Z"
            fill="currentColor"
          />
          <path
            d="M11.3866 9.43391C9.52664 8.19391 6.49331 8.19391 4.61997 9.43391C3.77331 10.0006 3.30664 10.7672 3.30664 11.5872C3.30664 12.4072 3.77331 13.1672 4.61331 13.7272C5.54664 14.3539 6.77331 14.6672 7.99997 14.6672C9.22664 14.6672 10.4533 14.3539 11.3866 13.7272C12.2266 13.1606 12.6933 12.4006 12.6933 11.5739C12.6866 10.7539 12.2266 9.99391 11.3866 9.43391Z"
            fill="currentColor"
          />
        </>
      ),
      active: true,
    },
    {
      id: "notifications",
      label: "Notifications",
      icon: (
        <>
          <path
            d="M12.8936 9.6587L12.227 8.55203C12.087 8.30536 11.9603 7.8387 11.9603 7.56536V5.8787C11.9603 4.31203 11.0403 2.9587 9.71362 2.32536C9.36695 1.71203 8.72695 1.33203 7.99362 1.33203C7.26695 1.33203 6.61362 1.72536 6.26695 2.34536C4.96695 2.99203 4.06695 4.33203 4.06695 5.8787V7.56536C4.06695 7.8387 3.94029 8.30536 3.80029 8.54536L3.12695 9.6587C2.86029 10.1054 2.80029 10.5987 2.96695 11.052C3.12695 11.4987 3.50695 11.8454 4.00029 12.012C5.29362 12.452 6.65362 12.6654 8.01362 12.6654C9.37362 12.6654 10.7336 12.452 12.027 12.0187C12.4936 11.8654 12.8536 11.512 13.027 11.052C13.2003 10.592 13.1536 10.0854 12.8936 9.6587Z"
            fill="currentColor"
          />
          <path
            d="M9.88678 13.3387C9.60678 14.112 8.86678 14.6654 8.00012 14.6654C7.47345 14.6654 6.95345 14.452 6.58678 14.072C6.37345 13.872 6.21345 13.6054 6.12012 13.332C6.20678 13.3454 6.29345 13.352 6.38678 13.3654C6.54012 13.3854 6.70012 13.4054 6.86012 13.4187C7.24012 13.452 7.62678 13.472 8.01345 13.472C8.39345 13.472 8.77345 13.452 9.14678 13.4187C9.28678 13.4054 9.42678 13.3987 9.56012 13.3787C9.66678 13.3654 9.77345 13.352 9.88678 13.3387Z"
            fill="currentColor"
          />
        </>
      ),
    },
    {
      id: "change-password",
      label: "Change Password",
      icon: (
        <>
          <path
            d="M7.99975 11.5679C8.5999 11.5679 9.08642 11.0813 9.08642 10.4812C9.08642 9.88105 8.5999 9.39453 7.99975 9.39453C7.3996 9.39453 6.91309 9.88105 6.91309 10.4812C6.91309 11.0813 7.3996 11.5679 7.99975 11.5679Z"
            fill="currentColor"
          />
          <path
            d="M12.1863 6.35203V5.5187C12.1863 3.7187 11.753 1.33203 7.99967 1.33203C4.24634 1.33203 3.81301 3.7187 3.81301 5.5187V6.35203C1.94634 6.58536 1.33301 7.53203 1.33301 9.8587V11.0987C1.33301 13.832 2.16634 14.6654 4.89967 14.6654H11.0997C13.833 14.6654 14.6663 13.832 14.6663 11.0987V9.8587C14.6663 7.53203 14.053 6.58536 12.1863 6.35203ZM7.99967 12.492C6.88634 12.492 5.98634 11.5854 5.98634 10.4787C5.98634 9.36537 6.89301 8.46536 7.99967 8.46536C9.10634 8.46536 10.013 9.37203 10.013 10.4787C10.013 11.592 9.11301 12.492 7.99967 12.492ZM4.89967 6.29203C4.84634 6.29203 4.79967 6.29203 4.74634 6.29203V5.5187C4.74634 3.56536 5.29967 2.26536 7.99967 2.26536C10.6997 2.26536 11.253 3.56536 11.253 5.5187V6.2987C11.1997 6.2987 11.153 6.2987 11.0997 6.2987H4.89967V6.29203Z"
            fill="currentColor"
          />
        </>
      ),
    },
    {
      id: "privacy-policy",
      label: "Privacy Policy",
      icon: (
        <>
          <path
            d="M10.6663 2.83203C10.6663 3.6587 9.99301 4.33203 9.16634 4.33203H6.83301C6.41967 4.33203 6.04634 4.16536 5.77301 3.89203C5.49967 3.6187 5.33301 3.24536 5.33301 2.83203C5.33301 2.00536 6.00634 1.33203 6.83301 1.33203H9.16634C9.57967 1.33203 9.95301 1.4987 10.2263 1.77203C10.4997 2.04536 10.6663 2.4187 10.6663 2.83203Z"
            fill="currentColor"
          />
          <path
            d="M12.5537 3.3538C12.4003 3.22713 12.227 3.12713 12.0403 3.0538C11.847 2.98046 11.6537 3.1338 11.6137 3.3338C11.387 4.4738 10.3803 5.3338 9.16699 5.3338H6.83366C6.16699 5.3338 5.54033 5.0738 5.06699 4.60046C4.72033 4.2538 4.48033 3.8138 4.38699 3.34046C4.34699 3.14046 4.14699 2.98046 3.95366 3.06046C3.18033 3.3738 2.66699 4.08046 2.66699 5.50046V12.0005C2.66699 14.0005 3.86033 14.6671 5.33366 14.6671H10.667C12.1403 14.6671 13.3337 14.0005 13.3337 12.0005V5.50046C13.3337 4.4138 13.0337 3.74713 12.5537 3.3538ZM5.33366 8.16713H8.00033C8.27366 8.16713 8.50033 8.3938 8.50033 8.66713C8.50033 8.94046 8.27366 9.16713 8.00033 9.16713H5.33366C5.06033 9.16713 4.83366 8.94046 4.83366 8.66713C4.83366 8.3938 5.06033 8.16713 5.33366 8.16713ZM10.667 11.8338H5.33366C5.06033 11.8338 4.83366 11.6071 4.83366 11.3338C4.83366 11.0605 5.06033 10.8338 5.33366 10.8338H10.667C10.9403 10.8338 11.167 11.0605 11.167 11.3338C11.167 11.6071 10.9403 11.8338 10.667 11.8338Z"
            fill="currentColor"
          />
        </>
      ),
    },
    {
      id: "terms-and-conditions",
      label: "Terms and Conditions",
      icon: (
        <>
          <path
            d="M10.6667 1.33203H5.33333C3 1.33203 2 2.66536 2 4.66536V11.332C2 13.332 3 14.6654 5.33333 14.6654H10.6667C13 14.6654 14 13.332 14 11.332V4.66536C14 2.66536 13 1.33203 10.6667 1.33203ZM5.33333 8.16536H8C8.27333 8.16536 8.5 8.39203 8.5 8.66536C8.5 8.9387 8.27333 9.16536 8 9.16536H5.33333C5.06 9.16536 4.83333 8.9387 4.83333 8.66536C4.83333 8.39203 5.06 8.16536 5.33333 8.16536ZM10.6667 11.832H5.33333C5.06 11.832 4.83333 11.6054 4.83333 11.332C4.83333 11.0587 5.06 10.832 5.33333 10.832H10.6667C10.94 10.832 11.1667 11.0587 11.1667 11.332C11.1667 11.6054 10.94 11.832 10.6667 11.832ZM12.3333 6.16536H11C9.98667 6.16536 9.16667 5.34536 9.16667 4.33203V2.9987C9.16667 2.72536 9.39333 2.4987 9.66667 2.4987C9.94 2.4987 10.1667 2.72536 10.1667 2.9987V4.33203C10.1667 4.79203 10.54 5.16536 11 5.16536H12.3333C12.6067 5.16536 12.8333 5.39203 12.8333 5.66536C12.8333 5.9387 12.6067 6.16536 12.3333 6.16536Z"
            fill="currentColor"
          />
        </>
      ),
    },
    {
      id: "faqs",
      label: "FAQs",
      icon: (
        <>
          <path
            d="M11.333 1.62109H4.66634C2.66634 1.62109 1.33301 2.95443 1.33301 4.95443V8.95443C1.33301 10.9544 2.66634 12.2878 4.66634 12.2878V13.7078C4.66634 14.2411 5.25967 14.5611 5.69967 14.2611L8.66634 12.2878H11.333C13.333 12.2878 14.6663 10.9544 14.6663 8.95443V4.95443C14.6663 2.95443 13.333 1.62109 11.333 1.62109ZM7.99967 9.73443C7.71967 9.73443 7.49967 9.50776 7.49967 9.23443C7.49967 8.96109 7.71967 8.73443 7.99967 8.73443C8.27967 8.73443 8.49967 8.96109 8.49967 9.23443C8.49967 9.50776 8.27967 9.73443 7.99967 9.73443ZM8.83967 6.96776C8.57967 7.14109 8.49967 7.25443 8.49967 7.44109V7.58109C8.49967 7.85443 8.27301 8.08109 7.99967 8.08109C7.72634 8.08109 7.49967 7.85443 7.49967 7.58109V7.44109C7.49967 6.66776 8.06634 6.28776 8.27967 6.14109C8.52634 5.97443 8.60634 5.86109 8.60634 5.68776C8.60634 5.35443 8.33301 5.08109 7.99967 5.08109C7.66634 5.08109 7.39301 5.35443 7.39301 5.68776C7.39301 5.96109 7.16634 6.18776 6.89301 6.18776C6.61967 6.18776 6.39301 5.96109 6.39301 5.68776C6.39301 4.80109 7.11301 4.08109 7.99967 4.08109C8.88634 4.08109 9.60634 4.80109 9.60634 5.68776C9.60634 6.44776 9.04634 6.82776 8.83967 6.96776Z"
            fill="currentColor"
          />
        </>
      ),
    },
    {
      id: "community-guidelines",
      label: "Community Guidelines",
      icon: (
        <>
          <path
            d="M10.793 1.33203H5.20634C2.77967 1.33203 1.33301 2.7787 1.33301 5.20536V10.7854C1.33301 13.2187 2.77967 14.6654 5.20634 14.6654H10.7863C13.213 14.6654 14.6597 13.2187 14.6597 10.792V5.20536C14.6663 2.7787 13.2197 1.33203 10.793 1.33203ZM10.4997 10.4987H5.49967C5.22634 10.4987 4.99967 10.272 4.99967 9.9987C4.99967 9.72536 5.22634 9.4987 5.49967 9.4987H10.4997C10.773 9.4987 10.9997 9.72536 10.9997 9.9987C10.9997 10.272 10.773 10.4987 10.4997 10.4987ZM10.4997 6.4987H5.49967C5.22634 6.4987 4.99967 6.27203 4.99967 5.9987C4.99967 5.72536 5.22634 5.4987 5.49967 5.4987H10.4997C10.773 5.4987 10.9997 5.72536 10.9997 5.9987C10.9997 6.27203 10.773 6.4987 10.4997 6.4987Z"
            fill="currentColor"
          />
        </>
      ),
    },
    {
      id: "contact-us",
      label: "Contact Us",
      icon: (
        <>
          <path
            d="M11.333 1.33203H4.66634C2.82634 1.33203 1.33301 2.8187 1.33301 4.65203V8.6387V9.30536C1.33301 11.1387 2.82634 12.6254 4.66634 12.6254H5.66634C5.84634 12.6254 6.08634 12.7454 6.19967 12.892L7.19967 14.2187C7.63967 14.8054 8.35967 14.8054 8.79967 14.2187L9.79967 12.892C9.92634 12.7254 10.1263 12.6254 10.333 12.6254H11.333C13.173 12.6254 14.6663 11.1387 14.6663 9.30536V4.65203C14.6663 2.8187 13.173 1.33203 11.333 1.33203ZM8.66634 9.16536H4.66634C4.39301 9.16536 4.16634 8.9387 4.16634 8.66536C4.16634 8.39203 4.39301 8.16536 4.66634 8.16536H8.66634C8.93967 8.16536 9.16634 8.39203 9.16634 8.66536C9.16634 8.9387 8.93967 9.16536 8.66634 9.16536ZM11.333 5.83203H4.66634C4.39301 5.83203 4.16634 5.60536 4.16634 5.33203C4.16634 5.0587 4.39301 4.83203 4.66634 4.83203H11.333C11.6063 4.83203 11.833 5.0587 11.833 5.33203C11.833 5.60536 11.6063 5.83203 11.333 5.83203Z"
            fill="currentColor"
          />
        </>
      ),
    },
    {
      id: "delete-account",
      label: "Delete Account",
      icon: (
        <>
          <path
            d="M14.0471 3.48536C12.9738 3.3787 11.9004 3.2987 10.8204 3.2387V3.23203L10.6738 2.36536C10.5738 1.75203 10.4271 0.832031 8.8671 0.832031H7.12043C5.5671 0.832031 5.42043 1.71203 5.31376 2.3587L5.17376 3.21203C4.55376 3.25203 3.93376 3.29203 3.31376 3.35203L1.95376 3.48536C1.67376 3.51203 1.47376 3.7587 1.50043 4.03203C1.5271 4.30536 1.7671 4.50536 2.0471 4.4787L3.4071 4.34536C6.90043 3.9987 10.4204 4.13203 13.9538 4.48536C13.9738 4.48536 13.9871 4.48536 14.0071 4.48536C14.2604 4.48536 14.4804 4.29203 14.5071 4.03203C14.5271 3.7587 14.3271 3.51203 14.0471 3.48536Z"
            fill="currentColor"
          />
          <path
            d="M12.8202 5.42797C12.6602 5.2613 12.4402 5.16797 12.2135 5.16797H3.78683C3.56016 5.16797 3.33349 5.2613 3.18016 5.42797C3.02683 5.59464 2.94016 5.8213 2.95349 6.05464L3.36683 12.8946C3.44016 13.908 3.53349 15.1746 5.86016 15.1746H10.1402C12.4668 15.1746 12.5602 13.9146 12.6335 12.8946L13.0468 6.0613C13.0602 5.8213 12.9735 5.59464 12.8202 5.42797ZM9.10682 11.8346H6.88683C6.61349 11.8346 6.38683 11.608 6.38683 11.3346C6.38683 11.0613 6.61349 10.8346 6.88683 10.8346H9.10682C9.38016 10.8346 9.60682 11.0613 9.60682 11.3346C9.60682 11.608 9.38016 11.8346 9.10682 11.8346ZM9.66683 9.16797H6.33349C6.06016 9.16797 5.83349 8.9413 5.83349 8.66797C5.83349 8.39464 6.06016 8.16797 6.33349 8.16797H9.66683C9.94016 8.16797 10.1668 8.39464 10.1668 8.66797C10.1668 8.9413 9.94016 9.16797 9.66683 9.16797Z"
            fill="currentColor"
          />
        </>
      ),
    },
  ];

  return (
    <ul className="nav nav-tabs setting-custom-tabs">
      {tabs.map((tab) => (
        <li className="nav-item" key={tab.id}>
          <span
            className={`nav-link text-body-b3 ${tab.id === currentTab ? "active" : ""}`}
            // data-bs-toggle="tab"
            // aria-current={tab.active ? "page" : undefined}
            // data-bs-target={`#${tab.id}`}
            onClick={(e) => (e.preventDefault, onTabChange(tab))}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {tab.icon}
            </svg>
            <img
              alt="image-alt"
              className="setting-active-state"
              src="/icons/small-active-state.svg"
            />
            <span>{tab.label}</span>
          </span>
        </li>
      ))}
    </ul>
  );
};

export default SettingsTabs;
